import Template00 from "./Template-00"
import TemplatePlain from "./Template-Plain"

export default {
    Template00,
    TemplatePlain
}
